module.exports = __webpack_public_path__ + "static/kovka1-bbe1365b894aa270c3d5440cdb1c58a8.png";